module.exports = __webpack_public_path__ + "media/audio125.259e7360.mp3";